import React from 'react';

const TermsOfService = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Terms of Service</h1>
        <p style={styles.updated}>Last updated: [DATE — fill in when published]</p>

        <p style={styles.p}>
          These Terms of Service ("Terms") govern your use of GrubClub
          (the "Service"), operated by Cactus Creative ("we," "us," or "our"). By creating
          an account or using the Service, you agree to these Terms.
        </p>

        <h2 style={styles.h2}>1. What the Service Is</h2>
        <p style={styles.p}>
          GrubClub lets a small group of people ("a Cookbook Club" or
          "group") create, upload, edit, and share recipes together. One member (the
          "owner") purchases access for the group, and can invite additional members up
          to the limit included in their plan. Features include recipe photo uploads,
          an AI-assisted recipe scanning tool, a shared meal planner, and printable
          recipe/cookbook exports.
        </p>

        <h2 style={styles.h2}>2. Accounts</h2>
        <p style={styles.p}>
          You must provide accurate information when registering and are responsible
          for keeping your password secure. You're responsible for all activity that
          happens under your account. Each account may belong to one Cookbook Club
          group at a time.
        </p>

        <h2 style={styles.h2}>3. Payments and Pricing</h2>
        <p style={styles.p}>
          Access to a Cookbook Club is a <strong>one-time purchase</strong> — we do not
          charge recurring subscription fees. Current pricing tiers, upgrade options,
          and add-ons (such as additional AI scan packs) are shown in the app at the
          time of purchase. Prices may change over time; changes do not affect access
          you've already purchased. Payments are processed securely by Stripe; we do
          not store your full card details ourselves.
        </p>
        <p style={styles.p}>
          <strong>Refunds:</strong> [Cactus Creative to decide and fill in an actual
          refund policy — e.g., "Refunds may be requested within 14 days of purchase by
          contacting support@cactuscreative.net" or "All purchases are final." This is a
          business decision, not something we've filled in for you.]
        </p>

        <h2 style={styles.h2}>4. The AI Recipe Scanning Feature</h2>
        <p style={styles.p}>
          When you use the "Scan Recipe" feature, the photo you provide is sent to
          Anthropic's Claude AI service to extract a draft recipe (title, ingredients,
          instructions). This extraction is AI-generated and may contain errors —
          you're responsible for reviewing and correcting the result before saving it.
          This feature is limited by the scan quota included in your plan; additional
          scans may be purchased separately.
        </p>

        <h2 style={styles.h2}>5. Your Content</h2>
        <p style={styles.p}>
          You retain ownership of the recipes, photos, and other content you upload
          ("Your Content"). By uploading Your Content, you grant us a license to store,
          process, and display it as needed to operate the Service — including sharing
          it with the other members of your Cookbook Club group (that's the whole
          point), storing photos via our storage provider (Supabase), and, when you
          use the scan feature, sending a photo to Anthropic's API as described above.
        </p>
        <p style={styles.p}>
          You're responsible for making sure you have the right to upload and share
          Your Content, and that it doesn't violate anyone else's rights or the law.
        </p>

        <h2 style={styles.h2}>6. Group Membership</h2>
        <p style={styles.p}>
          The group owner can invite and remove members, up to their plan's member
          limit. If you're removed from a group, or you leave one, you lose access to
          that group's recipes and content, though your own account remains active. If
          a group owner deletes the group, its recipes, photos, and invites are
          permanently removed.
        </p>

        <h2 style={styles.h2}>7. Acceptable Use</h2>
        <p style={styles.p}>
          Don't use the Service to upload illegal content, infringe on others' rights,
          abuse the invite or AI scanning systems, or attempt to disrupt or gain
          unauthorized access to the Service. We may suspend or terminate accounts that
          violate these Terms.
        </p>

        <h2 style={styles.h2}>8. Disclaimer of Warranties</h2>
        <p style={styles.p}>
          The Service is provided "as is." We don't guarantee it will be error-free,
          uninterrupted, or that AI-generated recipe content will be accurate — always
          review scanned recipes yourself, especially for allergen or safety-critical
          information.
        </p>

        <h2 style={styles.h2}>9. Limitation of Liability</h2>
        <p style={styles.p}>
          To the fullest extent permitted by law, Cactus Creative is not liable for any
          indirect, incidental, or consequential damages arising from your use of the
          Service.
        </p>

        <h2 style={styles.h2}>10. Changes to These Terms</h2>
        <p style={styles.p}>
          We may update these Terms from time to time. Continued use of the Service
          after changes are posted means you accept the updated Terms.
        </p>

        <h2 style={styles.h2}>11. Contact</h2>
        <p style={styles.p}>
          Questions about these Terms? Contact us at{' '}
          <a href="mailto:support@cactuscreative.net">support@cactuscreative.net</a>.
        </p>

        <p style={styles.disclaimer}>
          This document is a general template and has not been reviewed by an attorney.
          It's provided as a starting point, not legal advice.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '760px', margin: '40px auto', padding: '0 20px' },
  card: {
    backgroundColor: 'white', padding: '40px', borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', color: '#444', lineHeight: 1.6,
  },
  h1: { color: '#e67e22', marginBottom: '4px' },
  updated: { color: '#999', fontSize: '13px', marginBottom: '24px' },
  h2: { color: '#333', fontSize: '18px', marginTop: '28px', marginBottom: '10px' },
  p: { fontSize: '14px', marginBottom: '12px' },
  disclaimer: { fontSize: '12px', color: '#aaa', marginTop: '32px', borderTop: '1px solid #f0f0f0', paddingTop: '16px' },
};

export default TermsOfService;
